import React, { useContext, Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { ProductsDataContext } from '../../contexts/productsData.context'

import Text from '../text/text.component'
import PatternSelector from '../pattern-selector/pattern-selector.component'
import PatternItem from '../pattern-item/pattern-item.component'
import { regexSkuMatching } from '../../utils/bab/bab.utils'

import './pattern-grid.styles.scss'

const PatternGrid = ({
  patternsData,
  localPatterns,
  productTypeData,
  sizeData,
  maxQuantity,
  completedSubSteps,
  clickHandler,
  origineClickHandler,
  focusClickHandler,
  ...otherProps
}) => {
  const { t } = useTranslation('updatedBAB')
  const productsData = useContext(ProductsDataContext)

  const addDataToPattern = (pattern, productData) => {
    pattern.collection_priority = productData.collection_priority
    pattern.new = productData.new
    pattern.bestseller = productData.bestseller
    pattern.collection = productData.collection
    pattern.out_of_stock = productData.inventory_quantity <= productData.bab_sellable_quantity_threshold &&
      productData.inventory_policy !== 'continue'

    return pattern
  }

  const availablePatterns = patternsData.filter((pattern) => {
    const skuBase = productTypeData.skuPart
    const patternSkuPart = pattern.skuPart
    const sizeSkuPart = sizeData.skuPart
    const regexSku = regexSkuMatching(skuBase, patternSkuPart, sizeSkuPart)

    const productData = productsData.find(
      (productData) => regexSku.test(productData.sku)
    )

    if (typeof productData === 'undefined') return null

    addDataToPattern(pattern, productData)

    return productData
  })

  const sortByCollectionPriority = (availablePatterns) => {
    return availablePatterns.sort((patternA, patternB) =>
      patternB.collection_priority - patternA.collection_priority
    )
  }

  let permanentPatterns = availablePatterns.filter(
    (pattern) => pattern.category === 'permanent'
  )

  let newPatterns = availablePatterns.filter(
    (pattern) => pattern.category === 'new'
  )

  let seasonPatterns = availablePatterns.filter(
    (pattern) => pattern.category === 'season'
  )

  permanentPatterns = sortByCollectionPriority(permanentPatterns)
  newPatterns = sortByCollectionPriority(newPatterns)
  seasonPatterns = sortByCollectionPriority(seasonPatterns)

  return (
    <div className='pattern-grids' onClick={clickHandler}>
      <div className='pattern-items-grid'>
        <ul className='pattern-items'>
          {localPatterns.map((patternId, index) => (
            <PatternItem
              key={index}
              patternId={localPatterns[index]}
              productTypeId={productTypeData.id}
            />
          ))}
        </ul>

        {availablePatterns.length > 0 && (
          <Fragment>
            <Text
              content={t('patterns.categories.iconique.title')}
              classNames='pattern-grid-category-title'
              margins={[32, 0, 32, 0]}
            />
          </Fragment>
        )}

        {permanentPatterns.length > 0 && (
          <Fragment>
            <Text
              content={t('patterns.categories.iconique.permanent')}
              classNames='pattern-grid-category-text'
              margins={[4, 16, 4, 16]}
            />
            <div className='pattern-grid permanent-pattern-grid'>
              <ul className='pattern-selectors'>
                {permanentPatterns.map((pattern) => (
                  <PatternSelector
                    key={pattern.id}
                    pattern={pattern}
                    localPatterns={localPatterns}
                    productType={productTypeData.id}
                    sizeId={sizeData.id}
                    clickHandler={focusClickHandler}
                  />
                ))}
              </ul>
            </div>
          </Fragment>
        )}

        {newPatterns.length > 0 && (
          <Fragment>
            <Text
              content={t('patterns.categories.iconique.new')}
              classNames='pattern-grid-category-text'
              margins={[32, 16, 32, 16]}
            />
            <div className='pattern-grid new-pattern-grid'>
              <ul className='pattern-selectors'>
                {newPatterns.map((pattern) => (
                  <PatternSelector
                    key={pattern.id}
                    pattern={pattern}
                    localPatterns={localPatterns}
                    productType={productTypeData.id}
                    sizeId={sizeData.id}
                    clickHandler={focusClickHandler}
                  />
                ))}
              </ul>
            </div>
          </Fragment>
        )}

        {seasonPatterns.length > 0 && (
          <Fragment>
            <Text
              content={t('patterns.categories.iconique.season')}
              classNames='pattern-grid-category-text'
              margins={[32, 16, 32, 16]}
            />
            <div className='pattern-grid season-pattern-grid'>
              <ul className='pattern-selectors'>
                {seasonPatterns.map((pattern) => (
                  <PatternSelector
                    key={pattern.id}
                    pattern={pattern}
                    localPatterns={localPatterns}
                    productType={productTypeData.id}
                    sizeId={sizeData.id}
                    clickHandler={focusClickHandler}
                  />
                ))}
              </ul>
            </div>
          </Fragment>
        )}

        {productTypeData.id === 'diapers' && (
          <Fragment>
            <Text
              content={t('patterns.categories.origine.title')}
              classNames='pattern-grid-category-title'
              margins={[48, 0, 32, 0]}
            />
            <Text
              content={t('patterns.categories.origine.text')}
              classNames='pattern-grid-category-text'
            />
            <Text
              content={t('patterns.categories.origine.target')}
              classNames='pattern-grid-category-origine'
              clickHandler={origineClickHandler}
              margins={[16, 0, 16, 0]}
            />
          </Fragment>
        )}
      </div>
    </div>
  )
}

export default PatternGrid
